let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5ux2J")).then(() => parcelRequire('hm3w3'));